const COLOR_MAP = {
  Red: "R",
  Green: "G",
  Blue: "U",
  Purple: "P",
  Black: "B",
  Yellow: "Y",
  Orange: "O",
};

// Palworld-specific color map (no Black, so Blue uses "B")
const PALWORLD_COLOR_MAP = {
  Red: "R",
  Green: "G",
  Blue: "B",
  Purple: "P",
  Black: "B", // Not used in Palworld
  Yellow: "Y",
  Orange: "O",
};

type Colors =
  "Red" | "Green" | "Blue" | "Purple" | "Black" | "Yellow" | "Orange";

function normalizeColor(color: string): string {
  // Capitalize first letter, lowercase rest
  return color.charAt(0).toUpperCase() + color.slice(1).toLowerCase();
}

export function abbrevColor(color: string, game?: string): string {
  // Handle undefined or null
  if (!color) {
    return "";
  }

  // Select color map based on game
  const colorMap = game === "palworld" ? PALWORLD_COLOR_MAP : COLOR_MAP;

  if (color.includes("/")) {
    let colors = color.split("/");
    const color1: Colors = normalizeColor(colors[0].trim()) as Colors;
    const color2: Colors = normalizeColor(colors[1].trim()) as Colors;
    return `${colorMap[color1]}${colorMap[color2]}`;
  } else {
    const normalized = normalizeColor(color.trim()) as Colors;
    return colorMap[normalized] || "";
  }
}
